import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(-100%)', // Empieza desde la derecha
    },
    '100%': {
      transform: 'translateX(0)', // Termina en su posición original
    },
  },
  contactContainer: {
    animation: '$slideIn 1s ease-out',
    textAlign: 'center',
    padding: '1rem',
    color: '#fff',
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
  },
  formTitle: {
    margin: '0.5rem 0',
    background: 'linear-gradient(126deg, rgba(0,168,232,1) 2%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  formDescription: {
    color: '#ddd',
  },
  formContainer: {
    padding: '1rem',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    width: '100%',
     // Tamaño máximo del formulario
    '@media (max-width: 1200px)': {
      maxWidth: '300px', // Reduce el ancho en pantallas pequeñas
      padding: '0.5rem',
    },
  },
  inputField: {
    backgroundColor: '#FDFDFD33',
    '& .MuiInputBase-root': { color: '#fff' },
    '& .MuiFormLabel-root': { color: '#fff' },
    '& .MuiFormHelperText-root': { color: '#fff' },
    borderRadius: '5px',
  },
  mailImage: {
    maxWidth: '100%',
    width: '300px',
    height: 'auto',
    marginRight: '2rem',
    '@media (max-width: 600px)': {
      width: '200px', // Mantén un tamaño adecuado en pantallas pequeñas
      marginRight: '1rem',
    },
  },
});

export default useStyles;
